<template>
  <b-modal
    :active="active"
    has-modal-card
    trap-focus
    :can-cancel="!loading"
    aria-role="dialog"
    aria-modal
    @close="cancel"
  >
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ i18n.friendsFamily__ageWarningTitle[iso] }}
        </p>
        <button
          type="button"
          class="delete"
          :disabled="loading"
          @click="cancel"
        ></button>
      </header>
      <section class="modal-card-body">
        <p class="mb-3">
          {{ i18n.friendsFamily__ageWarningMessage[iso] }}
        </p>
        <div class="box py-3 px-4 mb-3">
          <p class="is-size-6 mb-1">
            <strong>Friends &amp; Family</strong>
          </p>
          <ul>
            <li v-for="(name, idx) in safeNames" :key="idx">
              {{ name }}
            </li>
          </ul>
        </div>
        <b-checkbox v-model="confirmed" :disabled="loading">
          {{ i18n.friendsFamily__ageWarningCheck[iso] }}
        </b-checkbox>
        <p class="is-size-7 has-text-grey mt-3 mb-0">
          {{ i18n.friendsFamily__invitationNote[iso] }}
        </p>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" :disabled="loading" @click="cancel">
          {{ i18n.friendsFamily__ageWarningCancel[iso] }}
        </button>
        <button
          class="button is-primary"
          type="button"
          :disabled="!confirmed || loading"
          :loading="loading"
          @click="confirm"
        >
          {{ i18n.friendsFamily__ageWarningConfirm[iso] }}
        </button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import i18n from "../utils/i18n";

export default {
  name: "ModalFFAgeWarning",
  props: {
    active: { type: Boolean, default: false },
    names: { type: Array, default: () => [] },
    iso: { type: String, default: "es" },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      i18n,
      confirmed: false,
    };
  },
  computed: {
    safeNames() {
      return (this.names || [])
        .map((name) => String(name || "").trim())
        .filter(Boolean);
    },
  },
  watch: {
    active(value) {
      if (value) this.confirmed = false;
    },
  },
  methods: {
    cancel() {
      if (this.loading) return;
      this.confirmed = false;
      this.$emit("cancel");
    },
    confirm() {
      if (!this.confirmed || this.loading) return;
      this.$emit("confirm");
    },
  },
};
</script>
